import React from 'react'
import { Box } from '@mui/material'
import { makeStyles } from "@mui/styles";
import Navbar from '../../components/Navbar'
import Footer from '../../components/Footer'

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100vh',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  container: {
    flex: 1,

  },
}))

const AuctionLayout = ({ children }) => {
  const classes = useStyles()
  return (
    <Box className={classes.root}>
      <Navbar />
      <Box className={classes.container}>
        {children}
      </Box>
      <Footer />
    </Box>
  )
}
export default AuctionLayout
